const
  //restHost = 'http://unikatum-cs.localhost',
  restHost = 'https://www.unikatum-kindermuseum.de',
  drupalFormat = 'YYYY-MM-DDTHH:mm:ss',
  drupalFormatFront = 'YYYY-MM-DD HH:mm:ss UTC',
  drupalFormatWithoutTime = 'YYYY-MM-DD',
  dayFormat = 'D.M.YYYY',
  dayWithTimeFormat = 'D.M.YYYY / HH.mm';

export { restHost, drupalFormat, dayFormat, dayWithTimeFormat, drupalFormatFront, drupalFormatWithoutTime };
